import {Box, Typography} from '@mui/material';

export default function NotFoundView(){
    return <Box sx={{display:'flex',alignItems:'center',justifyContent:'center',height:'100vh'}}>
        <Typography variant='h3' textAlign="center">404 page not found</Typography>
    </Box>
}